/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '@ant-design/icons';
import BoxIcon from './BoxIcon';

const BotLabSpaceSvg = ({ color }) => (
  <svg width="1em" height="1em" viewBox="3 3 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_2185_76620" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="4" y="3" width="17" height="18">
      <path fillRule="evenodd" clipRule="evenodd" d="M12.0325 5.22297C12.5601 5.22297 12.9878 4.7953 12.9878 4.26774C12.9878 3.74017 12.5601 3.3125 12.0325 3.3125C11.505 3.3125 11.0773 3.74017 11.0773 4.26774C11.0773 4.7953 11.505 5.22297 12.0325 5.22297ZM12.0329 20.0289C15.2823 20.0289 18.0178 17.829 18.8314 14.8374C19.5394 14.5204 20.0326 13.8097 20.0326 12.9838C20.0326 12.1579 19.5393 11.4472 18.8313 11.1302C18.0175 8.1388 15.2821 5.93915 12.0329 5.93915C8.78389 5.93915 6.04857 8.13856 5.23462 11.1297C4.52601 11.4464 4.03223 12.1575 4.03223 12.9838C4.03223 13.8101 4.52595 14.5211 5.23449 14.8379C6.0483 17.8293 8.78372 20.0289 12.0329 20.0289ZM9.40529 9.86045C8.54993 9.65233 7.70455 10.2372 7.5977 11.111L7.44282 12.3777C7.29857 13.5573 7.78742 14.7256 8.72883 15.4509C10.6508 16.9319 13.3294 16.9319 15.2514 15.4509C16.1928 14.7256 16.6816 13.5573 16.5374 12.3777L16.3825 11.111C16.2757 10.2372 15.4303 9.65233 14.5749 9.86045L14.1157 9.97219C12.719 10.312 11.2612 10.312 9.86457 9.97219L9.40529 9.86045ZM8.99536 12.8253C8.99536 12.1342 9.55559 11.574 10.2467 11.574C10.9377 11.574 11.498 12.1342 11.498 12.8253C11.498 12.9581 11.4773 13.0861 11.4389 13.2062C11.3688 13.4258 11.0996 13.4572 10.8867 13.3686C10.6896 13.2866 10.4733 13.2413 10.2464 13.2413C10.0197 13.2413 9.80353 13.2866 9.60646 13.3685C9.39357 13.457 9.12434 13.4255 9.05429 13.2059C9.01602 13.0859 8.99536 12.958 8.99536 12.8253ZM13.8618 11.5742C13.1707 11.5742 12.6105 12.1344 12.6105 12.8255C12.6105 12.9581 12.6312 13.086 12.6694 13.206C12.7395 13.4257 13.0087 13.4571 13.2216 13.3686C13.4187 13.2867 13.6348 13.2415 13.8616 13.2415C14.0884 13.2415 14.3047 13.2868 14.5019 13.3688C14.7148 13.4573 14.984 13.426 15.0541 13.2063C15.0924 13.0862 15.1131 12.9583 15.1131 12.8255C15.1131 12.1344 14.5529 11.5742 13.8618 11.5742Z" fill="#605DEC"/>
    </mask>
    <g mask="url(#mask0_2185_76620)">
      <rect x="14.6267" y="1.35156" width="16.8143" height="5.117" transform="rotate(64.2147 14.6267 1.35156)" fill={color === 'primary' ? '#4B4BB7' : color === 'transparent' ? 'rgba(255, 255, 255, 0.5)' : 'currentColor'} />
      <rect x="10.3267" y="4.21777" width="15.901" height="5.117" transform="rotate(64.2147 10.3267 4.21777)" fill={color === 'primary' ? '#605DEC' : color === 'transparent' ? 'rgba(255, 255, 255, 0.75)' : 'currentColor'} />
      <rect x="5.62891" y="6.2207" width="16.005" height="5.117" transform="rotate(64.2147 5.62891 6.2207)" fill={color === 'primary' ? '#A4A2F4' : color === 'transparent' ? '#FFFFFF' : 'currentColor'} />
    </g>
  </svg>
);

export const BotLabSpaceIcon = props => {
  const { color, isLoading, className, ...restProps } = props;
  return isLoading ? (
    <BoxIcon
      name="loader-circle"
      className={classNames(className, 'text-primary', 'animate-spin', 'pointer-events-none')}
      style={{ height: 37, width: 37 }} // fix alignment issue
    />
  ) : (
    <Icon
      component={() => <BotLabSpaceSvg color={color} />}
      className={className}
      {...restProps}
    />
  );
};

BotLabSpaceSvg.propTypes = {
  color: PropTypes.oneOf(['primary', 'transparent', 'flat'])
};

BotLabSpaceIcon.propTypes = {
  color: PropTypes.oneOf(['primary', 'transparent', 'flat']),
  isLoading: PropTypes.bool,
  className: PropTypes.string
};
